import { render, staticRenderFns } from "./ColorPalettePicker.vue?vue&type=template&id=0669c723&scoped=true&"
import script from "./ColorPalettePicker.vue?vue&type=script&lang=ts&"
export * from "./ColorPalettePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669c723",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VColorPicker,VSelect})
